import { RouterProvider } from "@tanstack/react-router";
import { router } from "router/routes";

import { AppProviders, REACT_QUERY_CLIENT } from "components/app_layout/AppProviders";
import { useProvidedGraphQlClient } from "lib/providers/GraphQlClientProvider";

/**
 * Entry point for the TanStack Router-based SPA.
 * Mounted by react_ujs from the spa ERB template.
 *
 * As pages are migrated to client-side routing, they are added as routes
 * in router/routes.tsx. Non-migrated pages continue to use the legacy
 * react_ujs per-page mounting.
 */
export default function RouterApp() {
  return (
    <AppProviders>
      <AuthedRouter />
    </AppProviders>
  );
}

/**
 * Bridges the token-authed GraphQL client into the router context, so loaders — which run
 * outside React — receive an already-authenticated client. The client comes from
 * GraphQlClientProvider and reads the current token per request, so loaders keep working across
 * a token refresh even though the client instance never changes.
 */
function AuthedRouter() {
  const graphQLClient = useProvidedGraphQlClient();
  return (
    <RouterProvider router={router} context={{ queryClient: REACT_QUERY_CLIENT, graphQLClient }} />
  );
}
